module.exports = __webpack_public_path__ + "img/banner-3.0e3a49ee.jpg";